/*
 *  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 *  Licensed under the Apache License, Version 2.0 (the "License").
 *  You may not use this file except in compliance with the License.
 *  A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 *  or in the "license" file accompanying this file. This file is distributed
 *  on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 *  express or implied. See the License for the specific language governing
 *  permissions and limitations under the License.
 */
import withAuth from '@amzn/base-ui/dist/withAuth';

import AnnouncementsList from '../parts/announcements/AnnouncementsList';
import CreateAnnouncement from '../parts/announcements/CreateAnnouncement';
import EditAnnouncement from '../parts/announcements/EditAnnouncement';

// eslint-disable-next-line no-unused-vars
function registerRoutes(routesMap, { location, appContext }) {
  const routes = new Map([
    ...routesMap,
    ['/announcements/create', withAuth(CreateAnnouncement)],
    ['/announcements/edit/:id', withAuth(EditAnnouncement)],
    ['/announcements', withAuth(AnnouncementsList)],
  ]);
  return routes;
}

const plugin = {
  registerRoutes,
};

export default plugin;
